<template>

	<editor v-if="isEdit" :review="reviewModel" @close="closeEditor"></editor>

	<!--Review Item -->
	<div class="review main hr" v-else>

		<div class="review__avatar-wrap">
			<img src="../../assets/img/review-user.png" class="review__avatar">
		</div>

		<div class="review__content">

			<div class="review__inner review__inner_flex">

				<div class="review__title-box">
					<div class="review__user-name bold">{{value.created_by.first_name}} {{value.created_by.last_name | one}}</div>
					<div class="review__title bold">{{value.title}}</div>
				</div>

				<div class="review__rating-box">

					<div class="review__rating-stars">
						<stars v-model="value.mark" :disabled="true"></stars>
					</div>

					<div class="review__date">{{value.created_at | ago}}</div>
				</div>
			</div>

			<div class="review__inner">
				<p class="review__paragrahp">
					{{value.text}}
				</p>
				<div class="review-btn_wrap" v-if="false">
					<a class="review__link" @click="openReply">Ответить</a>
				</div>

				<!--Review Answer Item -->
				<div class="review" :class="{'hr': i !== value.children.length - 1}" v-for="(reply, i) in value.children">
					<div class="review__avatar-wrap review__avatar-wrap_answer">
						<img src="../../assets/img/review-user.png" class="review__avatar">
					</div>

					<div class="review__content">

						<div class="review__inner review__inner_flex review__inner_answer">

							<div class="review__title-box">
								<div class="review__user-name review__user-name_answer bold">Антотина Юрьевна</div>
								<div class="review__title review__title_answer bold">Советую</div>
							</div>

						</div>

						<div class="review__inner">
							<p class="review__paragrahp">
								{{reply.text}}
							</p>
						</div>

					</div>
				</div>
				<!--Review Answer Item End -->

				<form v-if="isReply" class="review-answer-form" @submit.prevent="sendReply">
						<textarea v-model="replyModel.text" class="review-form__field review-form__field_textarea"
											placeholder="Введите текст"></textarea>

					<div class="basic-btn review-section__btn basic-btn_review-answer">
						<input type="submit" class="basic-btn__item" value="Ответить">
					</div>
				</form>

			</div>

		</div>

	</div>
	<!--Review Item End -->

</template>

<script>
	import _ from 'underscore';
	import moment from 'moment';
	import Stars from '@/components/Stars/Stars.vue'
	import Editor from '@/components/Reviews/Editor.vue';

	export default {
		name: "Review",
		props: ['value', 'whom', 'subject'],
		components: {Stars, Editor},
		data() {
			return {
				isEdit: false,
				isReply: false,
				reviewModel: {},
				replyModel: {
					text: ''
				}
			}
		},
		methods: {
			openEditor() {
				this.isEdit = true;
				this.reviewModel = this.value;
			},
			closeEditor() {
				this.isEdit = false;
				this.reviewModel = {};
			},
			openReply() {
				this.isReply = true;
			},
			closeReply() {
				this.isReply = false;
			},
			sendReply() {
				this.$store.dispatch('review/reply', {
					parent_id: this.value._id,
					obj_id: this.subject._id,
					text: this.replyModel.text
				}).then(() => {
					this.updateReviews();
					this.closeReply();
				});
			},
			updateReviews() {
				this.$emit('update');
			}
		}
	}
</script>

<style scoped>
	.review {
		margin-bottom: 0;
	}

	.review.main {
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// Review.vue?1be2438c